<template>
  <footer>
    <div class="fot-box">
      <div class="fot-top">
        <!-- footer logo -->
        <img class="fot-logo" src="@/assets/image/logo-b.png" alt="水石评级">
        <div class="fot-list">
          <div class="fot-item">
            <div class="fot-item-title">客户服务</div>
            <div class="fot-item-list">
              <div><a href="#">如何送评</a></div>
              <div><a href="#">收费标准</a></div>
              <div><a href="#">联系我们</a></div>
            </div>
          </div>
          <div class="fot-item">
            <div class="fot-item-title">相关网站</div>
            <div class="fot-item-list">
              <div><a href="#">水石评级</a></div>
            </div>
          </div>
          <div class="fot-item">
            <div class="fot-item-title">更多资源</div>
            <div class="fot-item-list">
              <div><a href="#">拍卖价格</a></div>
              <div><a href="#">经销商</a></div>
              <div><a href="#">公示公告</a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="fot-bottom">
        <div>版权所有：山东水石文物鉴定有限公司</div>
        <div style="padding-top: 8px;">鲁ICP备2024121548号‑1</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
  footer{
    // height: 287px;
    // position: absolute;
    // bottom: 0;
    // left: 0;
    background-color: #111111;
    color: #ffffff;
    width: 100%;
    .fot-box{
      width: 1200px;
      margin: 0 auto;
      padding: 50px 0 30px;
      .fot-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fot-logo{
          width: 200px;
        }
        .fot-list{
          display: flex;
          justify-content: space-between;
          .fot-item{
            margin-left: 50px;
            .fot-item-title{
              font-size: 19px;
            }
            .fot-item-list{
              font-size: 16px;
              div{
                padding-top: 5px;
                a{
                  color: #ccc;
                }
                a:hover{
                  color: #fff;
                }
              }
            }
          }
        }
      }
      .fot-bottom{
        text-align: center;
        padding-top: 50px;
      }
    }
  }
</style>